import { queryPost } from "@/core/service/api";

const standardtable = {
  namespaced: true,
  name: "start",
  state: {
    exChangeCode:''
  },
  mutations: {
    save(state, num) {
      Object.assign(state,{
        exChangeCode: num
      });
    }
  },
  actions: {
    saveCode(context,num){
      context.commit('save',num.amount);
    }
  }
};

export default standardtable;
